"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFirstVariantByInventory = exports.thumbImage = exports.getFirstVariant = exports.getProductDiscount = exports.getThumbImage = exports.getProductMeta = exports.getProductPrice = void 0;
const getProductPrice = (product, variantId) => {
    const { variants, price: p, listingPrice: lp } = product || {};
    const { items } = variants || {};
    if (Array.isArray(items) && items.length) {
        if (variantId) {
            const currentVariant = items.find((i) => i.id === variantId);
            if (currentVariant) {
                const { price, listingPrice } = currentVariant;
                return { price, listingPrice };
            }
        }
        const [{ price, listingPrice }] = items;
        return { price, listingPrice };
    }
    return { price: p, listingPrice: lp };
};
exports.getProductPrice = getProductPrice;
const getProductMeta = (product) => {
    if (!product)
        return {};
    const { variants, images } = product;
    const { items = [] } = variants || {};
    const { items: allImages = [] } = images || {};
    const sortedImages = Array.isArray(allImages)
        ? allImages.slice().sort((a, b) => { var _a, _b; return ((_a = a.position) !== null && _a !== void 0 ? _a : 1) - ((_b = b.position) !== null && _b !== void 0 ? _b : 1); })
        : [];
    const [, secondaryImage] = sortedImages;
    const variantsSortedByPosition = items
        .slice()
        .sort((a, b) => { var _a, _b; return ((_a = a.position) !== null && _a !== void 0 ? _a : 1) - ((_b = b.position) !== null && _b !== void 0 ? _b : 1); });
    let firstVariant = variantsSortedByPosition[0];
    if (variantsSortedByPosition) {
        for (let index = 0; index < variantsSortedByPosition.length; index++) {
            const element = variantsSortedByPosition[index];
            if (element.inventory && element.inventory > 0) {
                firstVariant = element;
                break;
            }
        }
    }
    const thumbImage = (0, exports.getThumbImage)(product, firstVariant);
    let discount = !!(product.listingPrice && product.price)
        ? Math.round(((product.listingPrice - product.price) * 100) / product.listingPrice)
        : 0;
    if (firstVariant) {
        discount = !!(firstVariant.listingPrice && firstVariant.price)
            ? Math.round(((firstVariant.listingPrice - firstVariant.price) * 100) /
                firstVariant.listingPrice)
            : 0;
    }
    return {
        thumbImage,
        secondaryImage,
        discount,
        firstVariant,
    };
};
exports.getProductMeta = getProductMeta;
const getThumbImage = (product, variant) => {
    var _a, _b;
    const { images, imageUrl } = product;
    if (imageUrl) {
        return {
            imageKey: imageUrl.split("/public/")[1] || "",
        };
    }
    if ((_b = (_a = variant === null || variant === void 0 ? void 0 : variant.images) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.length) {
        const variantStoredImages = Array.isArray(variant.images.items)
            ? variant.images.items
                .slice()
                .sort((a, b) => (a.position || 1) - (b.position || 1))
            : [];
        const thumbImage = variantStoredImages.find((i) => i.isThumb) || variantStoredImages[0];
        if (thumbImage)
            return thumbImage;
    }
    const { items: allImages = [] } = images || {};
    const sortedImages = Array.isArray(allImages)
        ? allImages.slice().sort((a, b) => (a.position || 1) - (b.position || 1))
        : [];
    return sortedImages.find((i) => i.isThumb) || sortedImages[0];
};
exports.getThumbImage = getThumbImage;
const getProductDiscount = (product, variant) => {
    if (variant) {
        const { price, listingPrice = 0 } = variant;
        if (!!listingPrice && listingPrice > price) {
            return Math.round(((listingPrice - price) * 100) / listingPrice);
        }
        return 0;
    }
    const { price, listingPrice = 0 } = product;
    if (!!listingPrice && listingPrice > price) {
        return Math.round(((listingPrice - price) * 100) / listingPrice);
    }
    return 0;
};
exports.getProductDiscount = getProductDiscount;
const getFirstVariant = (product, variantId) => {
    if (product) {
        const { variants } = product;
        const { items = [] } = variants || {};
        const [variant] = items;
        if (variantId) {
            const v = items.find((v) => v.id === variantId);
            if (v)
                return v;
        }
        return variant;
    }
    return null;
};
exports.getFirstVariant = getFirstVariant;
const thumbImage = (item) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (Array.isArray((_a = item.variants) === null || _a === void 0 ? void 0 : _a.items) && item.variantId) {
        const currVariant = (_b = item.variants) === null || _b === void 0 ? void 0 : _b.items.find((v) => v.id === item.variantId);
        if ((_d = (_c = currVariant === null || currVariant === void 0 ? void 0 : currVariant.images) === null || _c === void 0 ? void 0 : _c.items) === null || _d === void 0 ? void 0 : _d.length) {
            const thumbImage = (_f = (_e = currVariant === null || currVariant === void 0 ? void 0 : currVariant.images) === null || _e === void 0 ? void 0 : _e.items[0]) === null || _f === void 0 ? void 0 : _f.imageKey;
            return thumbImage;
        }
    }
    const thumbImage = (_h = (_g = item.images) === null || _g === void 0 ? void 0 : _g.items[0]) === null || _h === void 0 ? void 0 : _h.imageKey;
    return thumbImage;
};
exports.thumbImage = thumbImage;
const getFirstVariantByInventory = (variants) => {
    if (variants) {
        let selectedVariant = variants[0];
        for (let index = 0; index < variants.length; index++) {
            const element = variants[index];
            if (element.inventory && element.inventory > 0) {
                selectedVariant = element;
                break;
            }
        }
        return selectedVariant;
    }
};
exports.getFirstVariantByInventory = getFirstVariantByInventory;
